export default __webpack_public_path__ + "static/media/Mobileshopclient.7141c4e1.m4v";